// extracted by mini-css-extract-plugin
module.exports = {"root":"UserDropdown_root__EGmuv","dropdownMenu":"UserDropdown_dropdownMenu__4Ao3u","item":"UserDropdown_item__KQKOb","version":"UserDropdown_version__fRrXD"};